/**
 * Update selected items in Mainlist after search.
 *
 * @param commit
 * @param getters
 * @param payload
 */
export function updateSelection(_ref, payload) {
  var commit = _ref.commit,
    getters = _ref.getters;
  var selected = getters[payload.side + 'Mainlist'].selected;
  commit('UPDATE_MAINLIST_SELECTED', {
    data: selected,
    side: payload.side
  });
}

/**
 * Set data into mainlist.
 *
 * @param commit
 * @param dispatch
 * @param payload
 */
export function set(_ref2, payload) {
  var commit = _ref2.commit,
    dispatch = _ref2.dispatch;
  payload.data.wait = 'set-mainlist-' + payload.side;
  dispatch('api', payload.data, {
    root: true
  }).then(function (resp) {
    commit('SET_MAINLIST', {
      data: resp.data,
      side: payload.side
    });
  });
}

/**
 * Select/deselect from mainlist.
 *
 * @param commit
 * @param payload
 */
export function toggle(_ref3, payload) {
  var commit = _ref3.commit;
  commit('SET_MAINLIST_SELECTED', {
    item: payload.item,
    side: payload.side
  });
}

/**
 * Select all Items in mainlist.
 *
 * @param commit
 * @param payload
 */
export function selectAll(_ref4, payload) {
  var commit = _ref4.commit;
  commit('MAINLIST_SELECT_ALL', {
    item: payload.val,
    side: payload.side
  });
}

/**
 * Concat new data to old data in mainlist.
 *
 * @param commit
 * @param dispatch
 * @param payload
 */
export function push(_ref5, payload) {
  var commit = _ref5.commit,
    dispatch = _ref5.dispatch;
  payload.data.wait = 'set-mainlist-' + payload.side;
  return dispatch('api', payload.data, {
    root: true
  }).then(function (resp) {
    commit('PUSH_MAINLIST', {
      data: resp.data,
      side: payload.side
    });
  });
}

/**
 * Remove Selected items.
 *
 * @param commit
 * @param payload
 */
export function removeSelected(_ref6, payload) {
  var commit = _ref6.commit;
  commit('REMOVE_MAINLIST_SELECTED', {
    ids: payload.ids,
    sides: payload.sides
  });
}

/**
 * Update selected Queries in mainlist when assign action is triggered.
 *
 * @param commit
 * @param payload
 */
export function updateSelectedQueries(_ref7, payload) {
  var commit = _ref7.commit;
  commit('UPDATE_SELECTED_QUERIES', payload);
}

/**
 * Update selected Topics after action (Non Mesh Assignment).
 *
 * @param commit
 * @param payload
 */
export function updateSelectedTopics(_ref8, payload) {
  var commit = _ref8.commit;
  commit('UPDATE_SELECTED_TOPICS', payload);
}

/**
 * Expand/Collapse item in mainlist.
 *
 * @param commit
 * @param payload
 */
export function onExpandToggle(_ref9, payload) {
  var commit = _ref9.commit;
  commit('ON_EXPAND_TOGGLE', payload);
}

/**
 * Expand/Collapse child item in mainlist.
 *
 * @param commit
 * @param payload
 */
export function onExpandChildToggle(_ref10, payload) {
  var commit = _ref10.commit;
  commit('ON_EXPAND_CHILD_TOGGLE', payload);
}

/**
 * Expand all items in mainlist.
 *
 * @param commit
 * @param side
 */
export function expandAll(_ref11, side) {
  var commit = _ref11.commit;
  commit('EXPAND_ALL', side);
}

/**
 * Expand all children items in mainlist.
 *
 * @param commit
 * @param side
 */
export function expandAllChildren(_ref12, side) {
  var commit = _ref12.commit;
  commit('EXPAND_ALL_CHILDREN', side);
}

/**
 * Collapse all items.
 *
 * @param commit
 * @param side
 */
export function collapseAll(_ref13, side) {
  var commit = _ref13.commit;
  commit('COLLAPSE_ALL', side);
}

/**
 * Determinate when search is triggered to enable infinite scroll.
 *
 * @param commit
 * @param payload
 */
export function triggerSearch(_ref14, payload) {
  var commit = _ref14.commit;
  commit('TRIGGER_SEARCH', payload.side);
}